import React, { useState, useContext, useEffect } from 'react';
import toast from 'react-hot-toast';
import PropTypes from 'prop-types';
import { MdLunchDining, MdOutlinePeopleOutline } from 'react-icons/md';
import { Button, ButtonGroup } from '@/shared/components/Button';
import { FiAlignRight } from 'react-icons/fi';
import { IoMdTime, IoMdCloseCircle } from 'react-icons/io';
import { Modal } from 'react-bootstrap';
import { Chip } from '@mui/material';
import { Mealcontext } from '../../../../context/MealContext';
import MealDelete from '../utils/MealDeleteHandler';
import DeleteConfirmationModal from './DeleteModal';
import AddEditMeal from './AddEditMeal';
import AddAttachment from './AddAttachment';
import { GlobalVarContext } from '../../../../context/GlobalVarContext';
import { AuthContext } from '../../../../context/AuthContext';
import { PermissionContext } from '../../../../context/PermissionContext';

const MealCard = ({ 
  id, 
  mealname, 
  // restaurantid,
  restaurantname,
  description,
  capacity, 
  type, 
  price,
  finalprice, 
  format, 
  image, 
  isVeg,
  mealOffereds,
  cuisine,
  // refreshHandler,
}) => {
  const [mealOfferd, setMealOffered] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [deleteModalShow, setDeleteModal] = useState(false);
  const { apiGlobal } = useContext(GlobalVarContext);
  const { restaurantid, userid, currencyCode } = useContext(AuthContext);
  const { permissionsAccess } = useContext(PermissionContext);

 
  const { 
    setRefresh, 
    meals, 
    setMeals, 
    setIsDetailsClick, 
    setRestaurantDetailsId,
   } = useContext(Mealcontext);
  const handleDeleteModalShow = () => setDeleteModal(true);
  const handleDeleteModalClose = () => setDeleteModal(false);
  const [restaurantSelectoption, setRestaurantSelectOption] = useState(null);
  const [showAttachmentModal, setShowAtttachmentModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;
  // const [date, setDate] = useState(null);
  const toggleModalAttachment = () => setShowAtttachmentModal(!showAttachmentModal);
  const toggleModal = () => {
    setShowModal(!showModal);
    setMeals([]);
  };

//   let label;

//   if (isVeg === '1') {
//     label = <span className="bg-success text-white p-2 rounded">VEG</span>;
//   } else if (isVeg === '2') {
//     label = <span className="bg-danger text-white p-2 rounded w-50">NON-VEG</span>;
//   } else {
//     label = (
//       <div>
//         <span className="bg-success text-white p-2 rounded w-50">VEG</span>
//         <span className="bg-danger text-white p-2 rounded w-50">NON-VEG</span>
//       </div>
// );
//   }


  useEffect(() => {
    if (mealOffereds) {
      const mealOffer = mealOffereds.split(','); 

      const mappedMeals = mealOffer.map((meal) => {
        switch (meal) {
          case '1':
            return 'Breakfast';
          case '2':
            return 'Snacks';
          case '3':
            return 'Lunch';
          case '4':
            return 'Dinner';
          default:
            return ''; 
        }
      });

      setMealOffered(mappedMeals); 
    }
  }, [mealOffereds]); 

  // Edit Meal Data Handler
  const EditMealData = async (values) => {
    // console.log(restaurantSelectoption);
     // console.log(JSON.stringify(values, null, 2));
    // let selectedRestaurant = values.restaurant_id.value;
    // if (!selectedRestaurant) {
    //   selectedRestaurant = selectedid;
    // }
 

    // console.log(selectedid);
    const formattedValues = {
      items: meals,
  };
    // const sdate = new Date(values.start_date);
    // const startDate = sdate.toISOString().split('T')[0];
    // const edate = new Date(values.end_date);
    // const endDate = edate.toISOString().split('T')[0];

    const utcStartDate = values.start_date;
    const utcEndDate = values.end_date;

    // console.log(values.start_date);
    // console.log(values.end_date);

    // Convert to IST
    const startDate = new Date(utcStartDate);
    const endDate = new Date(utcEndDate);

    // IST offset is +5:30
   const istOffset = 5.5 * 60 * 60 * 1000;
   const startDateIST = new Date(startDate.getTime() + istOffset);
   const endDateIST = new Date(endDate.getTime() + istOffset); 
   
   const formatDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1)
    .padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

const formattedStartDate = formatDate(startDateIST);
const formattedEndDate = formatDate(endDateIST);

    const mealOffered = [];

    if (values.breakfast) {
        mealOffered.push('1');
    }
    if (values.Snacks) {
        mealOffered.push('2');
    }
    if (values.lunch) {
        mealOffered.push('3');
    }
    if (values.dinner) {
        mealOffered.push('4');
    }

    if (mealOffered.length === 0) {
      toast.error('Select at least one meal offered');
      return;
    }

    if (!values.format) {
      toast.error('Select meal format');
      return;
    }

    if (!values.veg) {
      toast.error('Select meal veg/nonveg type');
      return;
    }

    const location = [];
    

    if (values.locationsid && Array.isArray(values.locationsid)) {
      values.locationsid.forEach((locationItem) => {
        if (locationItem?.value) {
          location.push(locationItem.value); 
        }
      });
    } else if (values.locations && Array.isArray(values.locations)) {
      values.locations.forEach((locationItem) => {
        if (locationItem?.location_id) {
          location.push(locationItem.location_id); 
        }
      });
    }

    if (location.length === 0) {
      toast.error('location not selected....');
      return;
    }
   
    

    const formData = new FormData();
    formData.append('id', values.id);
    formData.append('name', values.name); 
    formData.append('restaurant_id', restaurantid);
    formData.append('location_ids', location.join(','));  
    formData.append('price', values.price); 
    formData.append('foc', values.foc); 
    formData.append('foc_on', values.foc_on); 
    formData.append('meal_type', values.meal_type); 
    formData.append('discription', values.description); 
    formData.append('photo', values.logo); 
    formData.append('start_date', formattedStartDate); 
    formData.append('end_date', formattedEndDate); 
    formData.append('markup_percentage', values.markup_percentage);
    formData.append('cuisine', values.cuisines); 
    formData.append('defaultMarkup', values.markup_percentage); 
    formData.append('meal_offered', mealOffered.join(',')); 
    formData.append('meal_format', values.format); 
    formData.append('veg_non_veg', values.veg); 
    
    if (Array.isArray(formattedValues.items)) {
      formData.append('items', JSON.stringify(formattedValues)); 
  } else {
      console.error('Items format is invalid');
  }

    formData.append('type', 2);
    formData.append('user_id', userid);

      formData.forEach((value, key) => {
        // console.log(`${key}: ${value}`);
    });

    try {
      setLoading(true);
      const response = await fetch(`${apiGlobal}/meal_edit.php`, {
          method: 'POST',
          body: formData,
      });
      if (!response.ok) {
          console.log(`Network response was not ok: ${response.statusText}`);
      }
      const responseData = await response.json();
      if (responseData.status && responseData.message === 'Data updated successfully.') {
          toast.success('Meal Edit Successfully...');
          setRefresh(prev => !prev);
          setShowModal(false);
          setLoading(false);
          setMeals([]);
          // refreshHandler();
      } else {
          toast.error(responseData.message);
      }
  } catch (error) {
      toast.error(error.message);
  } finally {
    setLoading(false);
    }
  };
  // image source 
  const logo = `${apiGlobal}/images/meal/${image}`;
 const MealDetails = () => {
  setIsDetailsClick(true);
  setRefresh(prev => !prev);
  // console.log(`mealDetailsClick${isDetailsClick}`);
  setRestaurantDetailsId(id);
 };

  
  const hideModalHandler = () => {
    setShowModal(false);
    setMeals([]);
  };


  return (
    <div className="card mb-3 position-relative" style={{ maxWidth: '100%' }}>
      <div className="row">
        <div className="col-md-4 col-12">
          <img 
            src={logo} 
            alt={mealname} 
            style={{
              width: '100%',
              height: '200px',
              objectFit: 'cover',
              marginTop: '12px',
              marginBottom: '12px',
              borderRadius: '10px',
            }} 
          />
        </div>

        <div className="col-md-4 col-12">
          <div className="card-body">
            <h3 className="card-text" style={{ color: 'black' }}>
              {mealname }  {restaurantname ? `/${restaurantname}` : '' }
            </h3>

            <p className="card-text"><FiAlignRight /> {description}</p>
            <p className="card-text">
              <IoMdTime /> Timing: {
                 mealOfferd.join(',')
              }
            </p>
            <p className="card-text">
              Type : {
                (() => {
                  switch (format) {
                    case '1':
                      return 'FIT';
                    case '2':
                      return 'GIT';
                    default:
                      return 'Delhivery';
                  }
                })()
              }
            </p>
            <p className="card-text">
              Format: {type}
            </p>

          </div>
        </div>

        <div className="col-md-4 col-12">
          <div className="card-body">
            {/* eslint-disable-next-line */}
            {isVeg === '1' ? (
              <Chip label="Veg" color="success" />
) : isVeg === '2' ? (
  <Chip label="Non-Veg" color="error" />
) : (
  <Chip label="Veg/Non-veg" color="warning" />
)}
            <p className="card-text mt-2"><MdLunchDining /> Cuisine: {cuisine}</p>
            <p className="card-text"><MdOutlinePeopleOutline /> Capacity: {capacity}</p>
          </div>
          <div className="card-body price d-flex align-items-center">
            <h2 className="card-text me-2" style={{ color: 'red' }}>
              {price} <p className="d-inline" style={{ fontSize: '0.75em' }}>AED</p> 
              {/* {price} <p className="d-inline" style={{ fontSize: '0.75em' }}>{currencyCode}</p> */}
            </h2>
            <h2 className="card-text me-2" style={{ color: 'blue' }}>
              {/* {finalprice} <p className="d-inline" style={{ fontSize: '0.75em' }}>AED</p> */}
            </h2>
          </div>
          <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
            {permissionsAccess?.[1]?.master_id === '2'
                  && permissionsAccess?.[1]?.create === 1 && (
                    <Button variant="outline-warning" size="sm" title="Add Attachment" onClick={toggleModalAttachment}>
                      +
                    </Button>
                  )}

            {permissionsAccess?.[1]?.master_id === '2'
                  && permissionsAccess?.[1]?.edit === 1 && (
                    <Button variant="outline-success" title="Edit" onClick={toggleModal}>
                      <span className="lnr lnr-pencil" /> Edit          
                    </Button>
                  )}
            

            {permissionsAccess?.[1]?.master_id === '2'
                  && permissionsAccess?.[1]?.delete === 1 && (
                    <Button variant="outline-danger" title="Delete" onClick={handleDeleteModalShow}>
                      <span className="lnr lnr-trash" /> Delete
                    </Button>
                  )}
           
            
            <Button variant="outline-primary" title="Details" onClick={() => MealDetails()}>
              <span className="lnr lnr-file-empty" /> Details
            </Button>
          </ButtonGroup>
        </div>
      </div>
      <DeleteConfirmationModal
        show={deleteModalShow}
        handleClose={handleDeleteModalClose}
        handleDelete={() => MealDelete(id, setRefresh, 2, userid, apiGlobal)}
        message="Are you sure you want to delete this meal?"
      />
      {/* {showModal && ( */}
      <Modal
        show={showModal}
        onHide={hideModalHandler}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Meal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddEditMeal
            onSubmit={EditMealData}
            id={id}
            setRestaurantSelectOption={setRestaurantSelectOption}
            loading={loading}
          />
        </Modal.Body>
      </Modal>
      {showAttachmentModal && (
      <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="exampleModalLabel">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="exampleModalLabel">Add Attachment</h3>
              <Button 
                type="button" 
                variant="primary" 
                rounded 
                size="sm" 
                onClick={toggleModalAttachment} 
                aria-label="Close"
              >
                <IoMdCloseCircle className="close-icon" />
              </Button>
            </div>
            <div className="modal-body">
              <AddAttachment uid={id} />
            </div>
          </div>
        </div>
      </div>
            )}
      
    </div>
  );
};

MealCard.propTypes = {
  id: PropTypes.string.isRequired,
  mealname: PropTypes.string.isRequired,
  restaurantname: PropTypes.string.isRequired,
  // restaurantid: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  finalprice: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  isVeg: PropTypes.string.isRequired,
  mealOffereds: PropTypes.string.isRequired,
  cuisine: PropTypes.string.isRequired,
  capacity: PropTypes.string.isRequired,
  // refreshHandler: PropTypes.func.isRequired,
};

export default MealCard;

